var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrisma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-10 w-10",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.284,36.035l-16.597,-34.606c-0.855,-1.783 -3.337,-1.93 -4.397,-0.26l-18.404,29.008c-0.397,0.625 -0.385,1.426 0.029,2.04l9.271,13.738c0.575,0.852 1.634,1.237 2.623,0.953l25.942,-7.458c1.457,-0.419 2.188,-2.048 1.533,-3.415zM40.618,37.279l-21.818,6.109c-0.505,0.142 -0.98,-0.305 -0.87,-0.818l7.735,-36.097c0.139,-0.65 1.023,-0.755 1.311,-0.157l14.265,29.621c0.248,0.544 -0.047,1.181 -0.623,1.342z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrisma);
export default __webpack_public_path__ + "static/media/prisma.e2670e2786b71269f4a8d4ec1a17fcbe.svg";
export { ForwardRef as ReactComponent };